import { render, staticRenderFns } from "./AddIncomeExpenses.vue?vue&type=template&id=b6c60cd8&scoped=true"
import script from "./AddIncomeExpenses.vue?vue&type=script&lang=js"
export * from "./AddIncomeExpenses.vue?vue&type=script&lang=js"
import style0 from "./AddIncomeExpenses.vue?vue&type=style&index=0&id=b6c60cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c60cd8",
  null
  
)

export default component.exports